import {createRoot} from 'react-dom/client';

import {IS_RUNNING_LOCALLY, WEBSITE_FRONTEND_URL} from '@shared/env';

import {Root} from '@website_frontend/root';

let domContentLoaded = false;
let doneRegisteringServiceWorker = false;

// Only render once the DOM has been loaded and the service worker has been registered
function maybeRenderRoot() {
  if (domContentLoaded && doneRegisteringServiceWorker) {
    const container = document.getElementById('root');
    if (container) {
      createRoot(container).render(<Root />);
    }
  }
}

// If running locally, reload the page when the ESBuild server is ready
if (IS_RUNNING_LOCALLY) {
  new EventSource(`${WEBSITE_FRONTEND_URL}/esbuild`).onmessage = () => location.reload();
}

// Check if the DOM has been loaded
document.addEventListener('DOMContentLoaded', () => {
  domContentLoaded = true;
  maybeRenderRoot();
});

// Register service worker (for image caching)
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(registration => {
        console.log('Service Worker registered:', registration.scope);
        doneRegisteringServiceWorker = true;
        maybeRenderRoot();
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
        doneRegisteringServiceWorker = true;
        maybeRenderRoot();
      });
  });
} else {
  console.log('Service Worker not supported');
}
